<template>
    <p>Stats Section</p>
</template>

<script>
    export default {}
</script>

<style scoped>

</style>
